import { createContext, useContext } from 'react';

const ThemeContext = createContext({
  setThemeName: () => {},
  themeName: 'lark',
});

export const ThemePreferenceProvider = ThemeContext.Provider;

export const useThemePreference = () => {
  return useContext(ThemeContext);
};
